import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/Layout/Layout'

// - Terminal Const
const Register = resolve => {
  require.ensure(['@/components/Auth/Register'], () => {
    resolve(require('@/components/Auth/Register'))
  })
}

const Verify = resolve => {
  require.ensure(['@/components/Auth/Verify'], () => {
    resolve(require('@/components/Auth/Verify'))
  })
}

const Home = resolve => {
  require.ensure(['@/components/Home'], () => {
    resolve(require('@/components/Home'))
  })
}

const InviteStore = resolve => {
  require.ensure(['@/components/Invite/Store/InviteStore'], () => {
    resolve(require('@/components/Invite/Store/InviteStore'))
  })
}

const InviteUser = resolve => {
  require.ensure(['@/components/Invite/User/InviteUser'], () => {
    resolve(require('@/components/Invite/User/InviteUser'))
  })
}

const Login = resolve => {
  require.ensure(['@/components/Auth/Login'], () => {
    resolve(require('@/components/Auth/Login'))
  })
}

// const NewOrganization = resolve => {
//   require.ensure(['@/components/Organization/NewOrganization'], () => {
//     resolve(require('@/components/Organization/NewOrganization'))
//   })
// }

// const OrganizationNotFound = resolve => {
//   require.ensure(['@/components/Organization/OrganizationNotFound'], () => {
//     resolve(require('@/components/Organization/OrganizationNotFound'))
//   })
// }

const Employee = resolve => {
  require.ensure(['@/components/Employee/Employee'], () => {
    resolve(require('@/components/Employee/Employee'))
  })
}

const ReportCenter = resolve => {
  require.ensure(['../../../PublicComponents/src/components/Reports/ReportCenter'], () => {
    resolve(require('../../../PublicComponents/src/components/Reports/ReportCenter'))
  })
}

// const ActivationByEmployee = resolve => {
//   require.ensure(['../../../PublicComponents/src/components/Reports/ActivationByEmployee'], () => {
//     resolve(require('../../../PublicComponents/src/components/Reports/ActivationByEmployee'))
//   })
// }

const HyperLinkPointReport = resolve => {
  require.ensure(['@/components/Reports/HyperlinkReport'], () => {
    resolve(require('@/components/Reports/HyperlinkReport'))
  })
}

const HyperLinkPointReportDetail = resolve => {
  require.ensure(['@/components/Reports/HyperlinkReportDetail'], () => {
    resolve(require('@/components/Reports/HyperlinkReportDetail'))
  })
}

const Error = resolve => {
  require.ensure(['../../../PublicComponents/src/components/Lottie/error'], () => {
    resolve(require('../../../PublicComponents/src/components/Lottie/error'))
  })
}

const Locations = resolve => {
  require.ensure(['../../../PublicComponents/src/components/Location/Locations'], () => {
    resolve(require('../../../PublicComponents/src/components/Location/Locations'))
  })
}

const NewLocation = resolve => {
  require.ensure(['../../../PublicComponents/src/components/Location/NewLocation'], () => {
    resolve(require('../../../PublicComponents/src/components/Location/NewLocation'))
  })
}

const Catalog = resolve => {
  require.ensure(['../../../PublicComponents/src/components/Catalog/Catalog'], () => {
    resolve(require('../../../PublicComponents/src/components/Catalog/Catalog'))
  })
}

const NewCatalog = resolve => {
  require.ensure(['../../../PublicComponents/src/components/Catalog/NewCatalog'], () => {
    resolve(require('../../../PublicComponents/src/components/Catalog/NewCatalog'))
  })
}

const Setting = resolve => {
  require.ensure(['@/components/Setting/setting'], () => {
    resolve(require('@/components/Setting/setting'))
  })
}

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/',
      name: 'layout',
      component: Layout,
      children: [
        { path: '/', component: Home, name: 'home', meta: {title: 'Dashboard'} },
        { path: '/error', component: Error, name: 'error', meta: {title: 'Error'} },
        { path: '/setting', component: Setting, name: 'setting', meta: {title: 'Setting'} },
        { path: '/invite/store', component: InviteStore, name: 'inviteStore', meta: {title: 'Invite Store'} },
        { path: '/invite/user', component: InviteUser, name: 'inviteUser', meta: {title: 'Invite User'} },
        { path: '/employee', component: Employee, name: 'employee', meta: {title: 'Employee'} },
        { path: '/locations', component: Locations, name: 'locations', meta: {title: 'Locations'} },
        { path: '/locations/new', component: NewLocation, name: 'NewLocations', meta: {title: 'Add Location'} },
        { path: '/catalog', component: Catalog, name: 'catalog', meta: {title: 'Catalog'} },
        { path: '/catalog/new', component: NewCatalog, name: 'newCatalog', meta: {title: 'New Product'} },
        { path: '/reportCenter', component: ReportCenter, name: 'reportCenter', meta: {title: 'Report Center'} },
        // { path: '/reports/activationByEmployee', component: ActivationByEmployee, name: 'actiavtionByEmployee' },
        { path: '/reports/hyperlinkPointReport', component: HyperLinkPointReport, name: 'hyperlinkPointsReport', meta: {title: 'Hyperlink Point Report'} },
        { path: '/reports/hyperlinkPointReport/:id', component: HyperLinkPointReportDetail, name: 'hyperlinkPointsReportDetail', meta: {title: 'Hyperlink Point Report'} }
      ]
    },
    { path: '/login', component: Login, name: 'login', meta: {title: 'Login'} },
    { path: '/register', component: Register, name: 'register', meta: {title: 'Sign Up'} },
    { path: '/verify', component: Verify, name: 'verify', meta: {title: 'Verifation'} }
    // { path: '/organization/new', component: NewOrganization, name: 'newOrg', meta: {title: 'Create Organization'} },
    // { path: '/organization/notfound', component: OrganizationNotFound, name: 'orgNotFound', meta: {title: 'Select Organization'} }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js